module.exports = "module.exports = __webpack_public_path__ + \"static/media/pageBody.bf4ad73d.template\";"